var acLinks = acLinks || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {

    $.fn.linkIcons = function( options ) {
        return this.each(function() {
            var linkIcons = Object.create(acLinks.linkIcons);
            linkIcons.init(this, options);
        });
    };

    $.fn.linkIcons.options = {
     };

    acLinks.linkIcons = {


        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.$link = self.$container.find(".link__anchor")
            self.$linkHref = self.$link.attr('href');
            self.$icon = self.$container.find(".link__svg use");
            self.bindElements();
        },

        bindElements () {
            var self = this;

            switch ( true ) {
                case self.$linkHref.indexOf('.pdf') > -1 :
                    self.$icon.attr("xlink:href" , "#pdf-icon");
                    self.$link.attr("download", '');

                    break;
                case self.$linkHref.indexOf('.jpg') > -1  || self.$linkHref.indexOf('.jpeg') > -1  :
                    self.$icon.attr("xlink:href" , "#download");
                    self.$link.attr("download", '');

                    break;
                case self.$linkHref.indexOf('.doc') > -1  :
                    self.$icon.attr("xlink:href" , "#download");
                    self.$link.attr("download", '');

                    break;
                case self.$linkHref.indexOf('.xls') > -1  :
                    self.$icon.attr("xlink:href" , "#download");
                    self.$link.attr("download", '');

                    break;
                 case self.$linkHref.indexOf('.png') > -1  :
                    self.$icon.attr("xlink:href" , "#download");
                    self.$link.attr("download", '');

                    break;
                case self.$linkHref.indexOf('.gif') > -1  :
                    self.$icon.attr("xlink:href" , "#download");
                    self.$link.attr("download", '');

                    break;
                default: self.testInternal();
            }

        },
        testInternal () {
            var self = this;
            const excludeLinkInsideParents = ['.hero-cta']
            if ( self.$link[0].hostname !== window.location.hostname && !self.$icon.parent().hasClass('same-external-icon')) {
                self.$icon.attr("xlink:href" , "#external");
            } else {
                self.$icon.attr("xlink:href" , "#right-arrow-o");
            }
        }
    }
});
